
import React from "react";

const TopSellingCategoriesCard = ({ data = [], total = 0 }) => (
  <div className="card custom-card overflow-hidden p-3">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">
        Category wise property statistics - {new Date().toLocaleString('default', { month: 'long' })}
      </h5>
    </div>
    <div className="card-body p-0">
      <div className="p-3 pb-0">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div>Total Properties</div>
          <div className="h6 mb-0">
            {total}
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table text-nowrap">
          <tbody>
            {data.map((row, idx) => (
              <tr key={row.id || idx}>
                <td><span className={`fw-medium top-category-name ${row.data}`}>{row.heading}</span></td>
                <td><span className="fw-medium">{row.price}</span></td>
                <td className="text-center"><span className="text-muted fs-12">{row.percent}% Gross</span></td>
                <td className="text-end"><span className={`badge bg-${row.color1}`}>{row.percent1}% <i className={`bi bi-arrow-${row.icon}`}></i></span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default TopSellingCategoriesCard;
